import { Component, OnInit } from '@angular/core';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { WorkspaceServiceService } from '../../../services/workspace-service.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data/data.service';
import { GlobalGridModeService } from '../../../services/globalGridMode/globalGridMode.service';
import { Alert } from '../../../model/alert';
import { MobileMainView } from '../../../enums/mobile-mainViews';
 
@Component({
  selector: 'mobile-alert-modal',
  template: require('./mobile-alert-modal.component.html'),
  styles: [require('./mobile-alert-modal.component.css')]
})
export class MobileAlertModalComponent extends AlertModalComponent {
 constructor(
    public workspaceService: WorkspaceServiceService,
    public modalService: NgbModal,
    public dataService: DataService,
    public globalGridMode: GlobalGridModeService,
    public activeModal: NgbActiveModal
  ) {
    super(workspaceService, modalService, dataService, globalGridMode, activeModal);
  }

  public newSymbol(event: MouseEvent, alert: Alert) {
    this.activeModal.dismiss();
    event.stopPropagation();
    this.workspaceService.data.activeAlertId = this.workspaceService.data.openedAlertId = alert.Id;
    this.workspaceService.data.mobileView = MobileMainView.CHARTING;
    const chart = this.workspaceService.data.charts["ach1"].instance;
    if(chart != null) chart.onSelectNewSymbol(alert.CurrencyPair);
  }

}